import { Component, ViewChild, ElementRef } from '@angular/core';
import { Configuration } from '../../configuration';
import { correctHeight, detectBody } from '../../app.helpers';
import { TopNavBarComponent } from '../common/topnavbar/topnavbar.component';
import { AuthService } from '../../auth/auth.service';
import {PermissionsHub} from '../../signalr/permissions.hub';
import {LoggedInUserService} from '../../auth/logged.in.user';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {
    private api: string;
    private permissionsHub: PermissionsHub;

    constructor(private authService: AuthService, element: ElementRef, configuration: Configuration) {
        var showBanner = element.nativeElement.getAttribute('showBanner');

        configuration.routing.api.baseUrl = element.nativeElement.getAttribute('api');
        configuration.routing.bidManagementUrl = element.nativeElement.getAttribute('bidManagementUrl');
        configuration.environmentInfo.environmentName = element.nativeElement.getAttribute('environmentName');
        configuration.routing.signalRHubs = element.nativeElement.getAttribute('signalRHubs');
        configuration.environmentInfo.showBanner = showBanner === 'true';
        configuration.routing.publicFacingUrl = element.nativeElement.getAttribute('publicFacingUrl');
        configuration.liveChat.host = element.nativeElement.getAttribute('liveChatHost') || '';
        configuration.liveChat.channelNumber = element.nativeElement.getAttribute('liveChatChannelNumber') || '';

        const basePath = element.nativeElement.getAttribute('basePath');

        if (basePath) {
            configuration.routing.basePath = `/${basePath}`;
        }

        //Use refresh token to re-auth if already logged in
        this.authService.startupTokenRefresh();
    }

    @ViewChild(TopNavBarComponent, { static: false }) topNav: TopNavBarComponent;

    detectIE(): void {
        var ua = window.navigator.userAgent;
        var is_ie = /MSIE|Trident/.test(ua);
    
        if (is_ie) {
            $('html').addClass('is-ie');
        }
    }

    ngAfterViewInit() {
        // Run correctHeight function on load and resize window event
        $(window).bind('load resize', () => {
            correctHeight();
            detectBody();
        });

        // Correct height of wrapper after metisMenu animation.
        $('.metismenu a').click(() => {
            setTimeout(() => {
                    correctHeight();
                },
                300);
        });

        // If IE add class to HTML tag
        this.detectIE();

        //Prevent grey modal overlay remaining after clicking Back
        $(window).on('popstate', () => {
            $('.modal-backdrop').remove();
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/app/app.component.ts